import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import styles from "./styles.scss";
import { Props } from "./types";
import { serviceCaller } from "../../../../composition";
import withStyles from "isomorphic-style-loader/withStyles";

const ReviewCard = ({ title, value, showAll, onEdit }: Props) => {
  return (
    <Card className={styles.card}>
      <CardBody className={styles.cardBody}>
        <Row>
          <Col>
            <h6 className={styles.header}>
              {title}{" "}
              {onEdit ? (
                <a className={styles.edit} onClick={onEdit}>
                  Edit
                </a>
              ) : null}
            </h6>
            <div
              className={`${styles.valueDisplay} ${
                showAll ? styles.multilineValue : styles.limitHeight
              }`}
            >
              {value}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default serviceCaller(withStyles(styles)(ReviewCard));
